export default __webpack_public_path__ + "static/media/Past reward claimed.90807bed.png";